// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'coa-add-to-group-dialog',
  templateUrl: './add-to-group-dialog.component.html',
  styleUrls: ['./add-to-group-dialog.component.scss'],
})
export class AddToGroupDialogComponent implements OnInit {
  clientId: number;
  selections: number[];
  showAddToGroup = true;

  constructor(
    private dialogRef: MatDialogRef<AddToGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { clientId: number, selections: number[] },
  ) {
  }

  ngOnInit(): void {
    this.clientId = this.data.clientId;
    this.selections = this.data.selections;
  }

  close(): void {
    this.dialogRef.close();
  }
}
